import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './portfolioReturnsPreview.png';

export const portfolioReturnsDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Portfolio Returns chart displays the price movement of your
                basket over time versus the order&apos;s previous day&apos;s
                close.
            </div>
            <div>
                Index comparisons can be added in the chart&apos;s configuration
                and used to view price changes in the market compared to your
                basket.
            </div>
        </>
    ),
    previews: [{ src: preview, altText: 'portfolio-reurns-preview' }],
};
